'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheckCircle } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Dialog, Loader } from '@/shared/components/ui';
import { AGENTE_CHECKLIST } from '../constants';
interface CriandoAgenteModalProps {
  onCancelar: () => void;
}
export const CriandoAgenteModal = t0 => {
  const $ = _c(11);
  const {
    onCancelar
  } = t0;
  const [etapaAtiva, setEtapaAtiva] = useState(0);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setEtapaAtiva(0);
      const intervalo = setInterval(() => {
        setEtapaAtiva(_temp);
      }, 5000);
      return () => clearInterval(intervalo);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-brand-600 h-14 w-14 animate-pulse rounded-full" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex flex-col items-center gap-2 text-center"><h1 className="text-heading-dark text-2xl font-semibold">Carregando seu agente...</h1><p className="text-label-muted text-sm leading-relaxed">Estamos carregando as configurações do seu agente. Em instantes você poderá conversar com ele e ver como vai negociar.</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== etapaAtiva) {
    t5 = AGENTE_CHECKLIST.map((label, indice) => {
      const concluido = etapaAtiva > indice;
      const ativo = etapaAtiva === indice;
      return <div key={label} className="flex items-center gap-2.5 rounded-[8px] border border-solid border-neutral-200 px-4 py-3">{concluido && <FeatherCheckCircle className="text-success-700 flex-none" />}{ativo && <Loader size="small" />}{!concluido && !ativo && <span className="flex h-4 w-4 flex-none items-center justify-center rounded-full border-2 border-solid border-neutral-500 text-[10px] font-bold text-neutral-500">{indice + 1}</span>}<span className={`text-sm font-semibold ${concluido ? "text-success-700" : ativo ? "text-heading-dark" : "text-neutral-500"}`}>{label}</span></div>;
    });
    $[4] = etapaAtiva;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onCancelar) {
    t6 = <Button variant="neutral-secondary" size="small" className="mt-1.5" onClick={onCancelar}>Cancelar</Button>;
    $[6] = onCancelar;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <Dialog open={true} onOpenChange={_temp2}><Dialog.Content className="w-[calc(100%-2rem)] max-w-[440px] items-center gap-6 rounded-[16px] px-6 py-8 sm:px-9 sm:py-10">{t3}{t4}<div className="flex w-full flex-col gap-2.5">{t5}{t6}</div></Dialog.Content></Dialog>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
function _temp(etapa) {
  return Math.min(etapa + 1, AGENTE_CHECKLIST.length - 1);
}
function _temp2() {}